// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FashionInspiration-components-explorationIcon-ExplorationIcon-module-iconFilter {
	-webkit-filter: invert(55%) sepia(5%) saturate(899%) hue-rotate(180deg) brightness(91%) contrast(92%);
	        filter: invert(55%) sepia(5%) saturate(899%) hue-rotate(180deg) brightness(91%) contrast(92%);
}
`, "",{"version":3,"sources":["webpack://./src/FashionInspiration/components/explorationIcon/ExplorationIcon.module.css"],"names":[],"mappings":"AAAA;CACC,qGAA6F;SAA7F,6FAA6F;AAC9F","sourcesContent":[".iconFilter {\n\tfilter: invert(55%) sepia(5%) saturate(899%) hue-rotate(180deg) brightness(91%) contrast(92%);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"iconFilter": `FashionInspiration-components-explorationIcon-ExplorationIcon-module-iconFilter`
};
module.exports = ___CSS_LOADER_EXPORT___;
